export type ReturnReasonSummary = {
  total: number;
  enabled: number;
  disabled: number;
  label: string;
  enabledLabel: string;
  disabledLabel: string;
};

export const getReturnReasonSummary = (
  allReasonIds: string[] | null | undefined = [],
  enabledReasonIds: string[] | null | undefined = [],
): ReturnReasonSummary => {
  const uniqueReasonIds = Array.from(new Set(allReasonIds ?? []));
  const enabledReasonSet = new Set(enabledReasonIds ?? []);
  const enabled = uniqueReasonIds.filter((id) =>
    enabledReasonSet.has(id),
  ).length;
  const disabled = uniqueReasonIds.length - enabled;

  return {
    total: uniqueReasonIds.length,
    enabled,
    disabled,
    label: `${enabled} enabled / ${disabled} disabled`,
    enabledLabel: `${enabled} enabled`,
    disabledLabel: `${disabled} disabled`,
  };
};
